var _rect, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcon1 = function SvgIcon1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81,
    height: 82,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    y: 1,
    fill: "url(#Icon-1_svg__a)",
    rx: 7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M60.388 61.073c11.117-11.115 11.117-29.137 0-40.252s-29.142-11.116-40.259 0-11.117 29.137 0 40.252 29.142 11.116 40.259 0M40.258 12.484v5.853M20.127 20.819l4.14 4.14M11.791 40.947h5.853M20.127 61.07l4.14-4.136M40.258 69.41v-5.857M60.385 61.07l-4.137-4.136M68.725 40.947h-5.858M60.385 20.819l-4.137 4.14"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M49.474 30.025 40.26 40.947l-11.581-7.314"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Icon-1_svg__a",
    x1: 40,
    x2: 40,
    y1: 1,
    y2: 81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB331"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F28230"
  })))));
};
export default SvgIcon1;